"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ToDoAlertTypeEnum = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

var _text = _interopRequireDefault(require("../../design-system/typography/text"));

var _ = require("../..");

var _date = require("../../design-system/date");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./ToDoCard.css");

var _styles = {
  "todo": "ToDoCard__todo___1e63y",
  "background-image": "ToDoCard__background-image___2U0pO",
  "todo-link": "ToDoCard__todo-link___3MM3D",
  "success": "ToDoCard__success___2YSRS",
  "time_sensitive": "ToDoCard__time_sensitive___3yB7O",
  "past_due": "ToDoCard__past_due___2S-MC",
  "card-border": "ToDoCard__card-border___2unAR",
  "card-shadow": "ToDoCard__card-shadow___2Zk5A"
};
var ToDoAlertTypeEnum;
exports.ToDoAlertTypeEnum = ToDoAlertTypeEnum;

(function (ToDoAlertTypeEnum) {
  ToDoAlertTypeEnum["RECOMMENDED"] = "recommended";
  ToDoAlertTypeEnum["TIME_SENSITIVE"] = "time_sensitive";
  ToDoAlertTypeEnum["PAST_DUE"] = "past_due";
  ToDoAlertTypeEnum["ERROR"] = "error";
  ToDoAlertTypeEnum["SUCCESS"] = "success";
})(ToDoAlertTypeEnum || (exports.ToDoAlertTypeEnum = ToDoAlertTypeEnum = {}));

const styles = _bind.default.bind(_styles);

const ToDoCard = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  label,
  title,
  description,
  primaryCtaText,
  primaryCtaLink,
  secondaryCtaText,
  secondaryCtaLink,
  priority,
  dueDate,
  alertType,
  secondaryCtaAsDismissible,
  setDismiss,
  backgroundImagePath,
  flexBasis = '33.3%'
}) => {
  const setLeftBorder = () => {
    if (priority !== 1) return;

    switch (alertType) {
      case ToDoAlertTypeEnum.SUCCESS:
        return ToDoAlertTypeEnum.SUCCESS;

      case ToDoAlertTypeEnum.TIME_SENSITIVE:
        return ToDoAlertTypeEnum.TIME_SENSITIVE;

      case ToDoAlertTypeEnum.PAST_DUE:
      case ToDoAlertTypeEnum.ERROR:
        return ToDoAlertTypeEnum.PAST_DUE;

      default:
        return;
    }
  };

  const composed_classname = (0, _bind.default)(styles('todo', {
    'card-border': alertType === ToDoAlertTypeEnum.RECOMMENDED || priority !== 1,
    'card-shadow': priority === 1
  }), className, styles(setLeftBorder()));
  const showSecondaryCta = ![ToDoAlertTypeEnum.ERROR, ToDoAlertTypeEnum.TIME_SENSITIVE].includes(alertType);
  const primaryCtaVariant = priority === 1 ? 'contained' : 'outlined';

  const renderHeader = () => {
    if ([ToDoAlertTypeEnum.TIME_SENSITIVE, ToDoAlertTypeEnum.PAST_DUE].includes(alertType)) {
      if (!dueDate) return;

      if (alertType === ToDoAlertTypeEnum.TIME_SENSITIVE) {
        return _react.default.createElement(_date.DateDisplay, {
          dataTestId: dataTestId && `${dataTestId}-${alertType}-header`,
          prefixText: 'Due',
          date: dueDate,
          displayType: _date.DisplayTypeEnum.warning
        });
      }

      if (alertType === ToDoAlertTypeEnum.PAST_DUE) {
        return _react.default.createElement(_date.DateDisplay, {
          dataTestId: dataTestId && `${dataTestId}-${alertType}-header`,
          prefixText: 'Due',
          date: dueDate,
          displayType: _date.DisplayTypeEnum.pastDue
        });
      }
    }

    if (alertType === ToDoAlertTypeEnum.ERROR && label) {
      return _react.default.createElement(_.Chip, {
        dataTestId: dataTestId && `${dataTestId}-${alertType}-header`,
        text: label,
        variant: 'hard_failure'
      });
    }

    if (alertType === ToDoAlertTypeEnum.RECOMMENDED) {
      return _react.default.createElement(_text.default, {
        dataTestId: dataTestId && `${dataTestId}-${alertType}-header`,
        text: label,
        color: _.Color.neutral._60,
        size: 13
      });
    }
  };

  return _react.default.createElement(_.Flex, {
    className: composed_classname,
    direction: 'column',
    justifyContent: 'space-between',
    dataTestId: dataTestId,
    basis: flexBasis
  }, backgroundImagePath && _react.default.createElement("div", {
    className: styles('background-image'),
    style: {
      backgroundImage: `url(${backgroundImagePath})`
    }
  }), _react.default.createElement(_.Flex, {
    direction: 'column',
    gap: 8,
    alignItems: 'flex-start'
  }, renderHeader(), _react.default.createElement(_text.default, {
    text: title,
    size: 18,
    variant: 'medium'
  }), _react.default.createElement(_text.default, {
    text: description,
    paddingBottom: 24
  })), _react.default.createElement(_.Flex, {
    gap: 16,
    alignItems: 'center'
  }, _react.default.createElement(_.Button, {
    dataTestId: dataTestId && `${dataTestId}-primaryCta`,
    variant: primaryCtaVariant,
    label: primaryCtaText,
    onClick: {
      location: primaryCtaLink,
      external: true,
      target: '_self'
    }
  }), secondaryCtaText && _react.default.createElement(_react.default.Fragment, null, secondaryCtaAsDismissible && setDismiss ? _react.default.createElement(_.Link, {
    dataTestId: dataTestId && `${dataTestId}-${alertType}-secondaryCta`,
    variant: 'medium',
    className: styles('todo-link'),
    onClick: setDismiss,
    text: secondaryCtaText,
    size: 15
  }) : _react.default.createElement(_react.default.Fragment, null, showSecondaryCta && _react.default.createElement(_.Link, {
    dataTestId: dataTestId && `${dataTestId}-${alertType}-secondaryCta`,
    variant: 'medium',
    className: styles('todo-link'),
    href: secondaryCtaLink,
    text: secondaryCtaText,
    external: true,
    iconSize: 13,
    size: 15
  })))));
});
var _default = ToDoCard;
exports.default = _default;